// extracted by mini-css-extract-plugin
module.exports = {"bmTextArea":"CustomTextArea_bmTextArea__2sVPm"};